// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as AdjustFareEntityMapper from "./AdjustFareEntityMapper.bs.js";
import * as PreviewAdjustFareApiModel from "../api-model/PreviewAdjustFareApiModel.bs.js";

function apiModelToState(res) {
  return {
          data: {
            popup_message: res.data.popup_message,
            order_fare: AdjustFareEntityMapper.orderFareApiModelToState(res.data.order_fare),
            new_customer_fare_without_prev_dues: res.data.new_customer_fare_without_prev_dues
          }
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PreviewAdjustFareApiModel.t_decode(json), "PreviewAdjustFareEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
